import { render, staticRenderFns } from "./ShortVacancyRedirect.vue?vue&type=template&id=6078f583&scoped=true&"
import script from "./ShortVacancyRedirect.vue?vue&type=script&lang=js&"
export * from "./ShortVacancyRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6078f583",
  null
  
)

export default component.exports